import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi, { UPLOAD_TIMEOUT } from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import MainButton from 'components/Buttons/MainButton'
import AlertDialog from 'components/AlertDialog'
import Phone from 'services/Phone'
import Address from 'services/Address'
import cutileiLogo from 'icons/cutilei-logo.png'
import { format as formatCNPJ } from '@fnando/cnpj'
import { format as formatCPF } from '@fnando/cpf'

import {
  Container,
  Form,
  Row,
  Info,
  Image,
  TextRow,
  SubTitle,
  InfoText,
  ErrorContainer
} from '../styles'

export default function Confirmation ({
  businessData = {},
  services = []
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const [submitting, setSubmitting] = useState (false)
  const [showOkDialog, setShowOkDialog] = useState (false)
  const navigate = useNavigate ()

  const handleSubmit = async () => {
    setSubmitting (true)
    setErrorMessage (null)
    
    try {
      const { logo, password, social_medias } = businessData

      const { data: business } = await cutileiApi.post ('/businesses', businessData)
      const { data: loginData } = await cutileiApi.post ('/auth/businesses', {
        businessId: business.id,
        password
      })

      const requestAuth = {
        headers: {'Authorization': `Bearer ${loginData.token}`}
      }

      await cutileiApi.post (
        `/businesses/${business.id}/services`, {services}, requestAuth
      )

      if (social_medias.some (socialMedia => socialMedia.link !== '')) {
        await cutileiApi.post (
          `/businesses/${business.id}/social_medias`, {social_medias}, requestAuth
        )
      }

      if (logo) {
        const formData = new FormData ()
        formData.append ('profile_picture', logo.file, logo.file.name)

        await cutileiApi.put (`/businesses/${business.id}/profile_picture`, formData, {
          // Upload/download nao cabe no timeout padrao: rede movel ruim leva mais que 30 s.
          timeout: UPLOAD_TIMEOUT,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      }

      setSubmitting (false)
      AuthService.signIn (loginData)
      toggleOkDialog ()
    } catch (error) {
      setSubmitting (false)
      logApiError (error)
    }
  }

  const toggleOkDialog = () => setShowOkDialog (!showOkDialog)

  return (
    <Container style={{paddingTop: 0}}>
      <SubTitle style={{marginBottom: 15, marginTop: -10}}>
        Confirme seus dados
      </SubTitle>
      <Form style={{width: 460}}>
        <Info>
          <SubTitle>Dados do salão</SubTitle>
          <Row style={{marginBottom: 10}}>
            <Image src={businessData.logo?.url ?? cutileiLogo}/>
          </Row>
          <TextRow>
            <SubTitle>Nome fantasia:</SubTitle>
            <InfoText>{businessData.name}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>Razão social:</SubTitle>
            <InfoText>{businessData.corporate_name}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>
              {businessData.use_cnpj ? 'CNPJ' : 'CPF'}:
            </SubTitle>
            <InfoText>
              {businessData.use_cnpj
                ? formatCNPJ (businessData.cnpj)
                : formatCPF (businessData.cnpj)
              }
            </InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>E-mail:</SubTitle>
            <InfoText>{businessData.email}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>Celular:</SubTitle>
            <InfoText>{Phone.formatPhone (businessData.cellphone, true)}</InfoText>
          </TextRow>
          {businessData.phone && (
            <TextRow>
              <SubTitle>Telefone:</SubTitle>
              <InfoText>{Phone.formatPhone (businessData.phone, true)}</InfoText>
            </TextRow>
          )}
        </Info>
      </Form>
      <Form style={{width: 460}}>      
        <Info>
          <SubTitle>Dados do responsável</SubTitle>
          <TextRow>
            <SubTitle>Nome:</SubTitle>
            <InfoText>{businessData.owner}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>E-mail:</SubTitle>
            <InfoText>{businessData.owner_email}</InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>Celular:</SubTitle>
            <InfoText>{Phone.formatPhone (businessData.owner_phone, true)}</InfoText>
          </TextRow>
        </Info>
      </Form>
      <Form style={{width: 460}}>
        <Info>
          <SubTitle>Endereço</SubTitle>
          <InfoText>{Address.formatAddress (businessData.address)}</InfoText>
          <TextRow>
            <InfoText>
              CEP: {Address.formatCep (businessData.address.postal_code)}
            </InfoText>
          </TextRow>
        </Info>
      </Form>
      {errorMessage && (
        <ErrorContainer>
          <p>{errorMessage}</p>
        </ErrorContainer>
      )}
      <MainButton
        label='Finalizar cadastro'
        onClick={handleSubmit}
        disabled={submitting}
        loading={submitting}
        width={160}
        style={{marginBottom: 20}}
      />
      <AlertDialog
        visible={showOkDialog}
        title={`Bem-vindo à Cutilei, ${businessData.name}`}
        message={
          <>
            <InfoText>
              Seu salão foi cadastrado com sucesso!
            </InfoText>
            <InfoText>
              Você será redirecionado para a sua área logada para prosseguir com as demais configurações assim que seu salão for aprovado pela Cutilei.
            </InfoText>
          </>
        }
        confirmText='Ok'
        onConfirm={() => navigate ('/business', { replace: true })}
        onClose={() => navigate ('/business', { replace: true })}
      />
    </Container>
  )
}
